import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { STATIC_PRODUCTS } from "../../lib/staticProducts";

export default function BooksPreview() {
    const books = STATIC_PRODUCTS.filter((p) => p.category === "buch").slice(0, 3);

    return (
        <section
            id="buecher"
            data-testid="books-preview-section"
            className="relative py-24 md:py-32 bg-cream-100 border-t border-cream-300"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 md:gap-16 items-center">
                <div className="md:col-span-5 reveal">
                    <span className="divider-dot mb-8"><span>Buchhandlung</span></span>
                    <div className="flex items-start gap-4 mb-6">
                        <BookOpen size={28} className="text-mauve-500 mt-2 shrink-0" strokeWidth={1.2} />
                        <h2 className="font-serif font-light text-4xl sm:text-5xl text-ink-900 tracking-tight leading-[1.05]" data-testid="books-preview-heading">
                            Worte, die <em className="italic text-mauve-500">Wurzeln schlagen.</em>
                        </h2>
                    </div>
                    <p className="text-base md:text-lg text-ink-700 leading-relaxed font-light max-w-md">
                        Eine kleine, sorgfältig kuratierte Auswahl an Büchern — für den Weg des Wissens: Lesen, Nachdenken und Wiederholen.
                    </p>
                    <Link to="/buecher" data-testid="books-preview-cta" className="mt-8 group inline-flex items-center gap-3 bg-mauve-500 text-cream-50 hover:bg-mauve-600 transition-colors px-8 py-4 text-xs tracking-[0.28em] uppercase font-light">
                        Zur Buchhandlung
                        <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                    </Link>
                </div>

                <div className="md:col-span-7 reveal">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
                        {books.map((b, i) => (
                            <Link key={b.id} to="/buecher" data-testid={`books-preview-${b.id}`} className={`group block ${i === 1 ? "sm:mt-8 md:mt-12" : ""}`}>
                                <div className="img-frame aspect-[3/4] mb-3">
                                    <img src={b.image_url} alt={b.name} className="w-full h-full object-cover" />
                                </div>
                                <p className="font-serif text-base md:text-lg text-ink-900 line-clamp-2">{b.name}</p>
                                <p className="mt-2 text-[11px] tracking-[0.25em] uppercase text-mauve-500">
                                  Bald erhältlich 
                                </p>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
